import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { auth } from "./lib/api";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Scouting from "./pages/Scouting";
import TenderDetail from "./pages/TenderDetail";
import Decisions from "./pages/Decisions";
import Partners from "./pages/Partners";
import Analytics from "./pages/Analytics";
import AdminPortals from "./pages/AdminPortals";
import FAQ from "./pages/FAQ";
import HelpPage from "./pages/HelpPage";
import ProceduresList, { ProcedureDetail } from "./pages/Procedures";
import EUTenders from "./pages/EUTenders";
import Notifications from "./pages/Notifications";

function Protected({ children }) {
  return auth.getToken() ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/welcome" replace />} />
          <Route path="/welcome" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/scouting" element={<Protected><Scouting /></Protected>} />
          <Route path="/eu-tenders" element={<Protected><EUTenders /></Protected>} />
          <Route path="/tenders/:id" element={<Protected><TenderDetail /></Protected>} />
          <Route path="/decisions" element={<Protected><Decisions /></Protected>} />
          <Route path="/partners" element={<Protected><Partners /></Protected>} />
          <Route path="/analytics" element={<Protected><Analytics /></Protected>} />
          <Route path="/admin/portals" element={<Protected><AdminPortals /></Protected>} />
          <Route path="/procedures" element={<Protected><ProceduresList /></Protected>} />
          <Route path="/procedures/:pid" element={<Protected><ProcedureDetail /></Protected>} />
          <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
          <Route path="/faq" element={<Protected><FAQ /></Protected>} />
          <Route path="/help/:page" element={<Protected><HelpPage /></Protected>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
